import { useDispatch, useSelector } from "react-redux";
import { Flex, FlexBetween } from "../styled/flex";
import { Mobile, PC } from "../styled/responsive";
import styled, { css } from "styled-components";
import MobileButton from "./mobile/button";
// import ChainSwitch from "./chainSwitch";
import LinkOrigin from "../styled/link";
import Navi from "./navi";
import {
  closeMobileMenu,
  mobileMenuFoldedSelector,
  toggle,
} from "../../store/reducers/mobileMenuSlice";
import { mdcss, mobilecss } from "../../styles/responsive";
import { useEffect } from "react";
import { useWindowSize } from "@osn/common";
import ExploreInputOrigin from "../../components/home/explore/input";
import { useLocation } from "react-router";
import { MOBILE_SIZE } from "@osn/constants";
import { getChainLogo } from "../../utils/chain";
import { useScrollLock } from "../../utils/hooks/useScrollLock";
import { HeaderMenuItem } from "./styled";
import NodeSwitch from "../nodeSwitch";
import MobileNodeSwitch from "./mobileNodeSwitch";

const headerHeight = 68;

const StyleLogo = styled(getChainLogo())`
  path {
    fill: ${(props) => props.theme.fontPrimary};
  }
`;

const Link = styled(LinkOrigin)`
  display: block;
`;

const LogoLink = styled(LinkOrigin)`
  line-height: 0;
`;

const Wrapper = styled(FlexBetween)`
  height: ${headerHeight}px;
`;

const MenuWrapper = styled(Flex)`
  margin-left: 64px;
`;

const MenuItem = styled(HeaderMenuItem)``;

const MobileMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  background-color: ${(p) => p.theme.fillPanel};

  ${mobilecss(css`
    padding: 0 16px;
  `)}

  box-sizing: border-box;
  position: fixed !important;
  top: ${headerHeight}px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  z-index: 2;
  gap: 16px;
`;

const ExploreInputWrapper = styled.div`
  position: relative;
  display: flex;
`;
const ExploreInputPCWrapper = styled(ExploreInputWrapper)`
  margin-right: 16px;
  width: 240px;

  .explore-dropdown {
    right: 0;
    width: 100%;
    top: 44px;
  }

  ${mdcss(css`
    display: none;
  `)}
`;
const ExploreInputMobileWrapper = styled(ExploreInputWrapper)`
  & .explore-dropdown {
    width: auto;
    top: 44px;
  }
`;
const ExploreInput = styled(ExploreInputOrigin)`
  display: inline-flex;
  flex: 1;
`;

export default function Header() {
  const showMobileMenu = !useSelector(mobileMenuFoldedSelector);
  const dispatch = useDispatch();
  const location = useLocation();
  const shouldShowPCExplore = location.pathname !== "/";

  const { width } = useWindowSize();

  useEffect(() => {
    if (width > MOBILE_SIZE) {
      dispatch(closeMobileMenu());
    }
  }, [dispatch, width]);

  const [, setIsLock] = useScrollLock();
  useEffect(() => setIsLock(showMobileMenu), [showMobileMenu, setIsLock]);

  return (
    <Wrapper>
      <FlexBetween style={{ flex: 1 }}>
        <LogoLink
          to={"/"}
          onClick={() => {
            dispatch(closeMobileMenu());
          }}
          className=" lin"
        >
          <StyleLogo />
        </LogoLink>

        <PC>
          <FlexBetween style={{ flex: 1 }}>
            <MenuWrapper>
              <Link to={"/blocks"}>
                <MenuItem>Blocks</MenuItem>
              </Link>
              <Link to={"/contracts"}>
                <MenuItem>Contracts</MenuItem>
              </Link>
              <Link to={"/did"}>
                <MenuItem>DID</MenuItem>
              </Link>
            </MenuWrapper>

            <Flex>
              {shouldShowPCExplore && (
                <ExploreInputPCWrapper>
                  <ExploreInput small />
                </ExploreInputPCWrapper>
              )}
              <Flex gap={8}>
                {/* <ChainSwitch /> */}
                <NodeSwitch />
              </Flex>
            </Flex>
          </FlexBetween>
        </PC>

        <Mobile>
          <MobileButton
            onClick={() => {
              dispatch(toggle());
            }}
            mobileMenuFolded={!showMobileMenu}
          />
          {showMobileMenu && (
            <MobileMenuWrapper>
              <ExploreInputMobileWrapper>
                <ExploreInput />
              </ExploreInputMobileWrapper>

              {/* <ChainSwitch /> */}
              <MobileNodeSwitch />
              <Navi />
            </MobileMenuWrapper>
          )}
        </Mobile>
      </FlexBetween>
    </Wrapper>
  );
}
